"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadForm = void 0;
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
var withMName_1 = require("./utils/withMName");
var underscore_1 = __importDefault(require("underscore"));
var Backbone = __importStar(require("backbone"));
var DownloadForm = /** @class */ (function (_super) {
    __extends(DownloadForm, _super);
    function DownloadForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DownloadForm.prototype.events = function () {
        return {
            'suggestion:match input': this.onSuggestionMatch.mname,
            'suggestion:miss input': this.onSuggestionMiss.mname,
            'change select': this.updateFormStatus.mname,
            'change input:radio': this.onChangeFormat.mname
        };
    };
    DownloadForm.prototype.initialize = function () {
        this.button = this.$el.find('.js-submit');
        this.buttonMatch = !this.$el.find('input:text').length;
        this.updateFormStatus();
    };
    DownloadForm.prototype.render = function () {
        return this;
    };
    DownloadForm.prototype.validInput = function () {
        var _a;
        return ((_a = this.buttonMatch) !== null && _a !== void 0 ? _a : false) &&
            this.allSelectsChosen() &&
            this.radioSelected();
    };
    DownloadForm.prototype.updateFormStatus = function () {
        var _a;
        var validInput = this.validInput();
        var enableWithNull = validInput ? null : 'true';
        (_a = this.button) === null || _a === void 0 ? void 0 : _a.attr('disabled', enableWithNull);
    };
    DownloadForm.prototype.onChangeFormat = function () {
        if (this.$el.find('input:radio:checked').val() === 'ppt') {
            this.$el.find('.js-year').addClass('disabled');
            this.$el.find('.js-year select').val('').change();
            this.$el.find('.js-year').hide();
        }
        else {
            this.$el.find('.js-year').removeClass('disabled');
            this.$el.find('.js-year').show();
        }
        return this.updateFormStatus();
    };
    DownloadForm.prototype.onSuggestionMatch = function () {
        this.buttonMatch = true;
        return this.updateFormStatus();
    };
    DownloadForm.prototype.onSuggestionMiss = function () {
        this.buttonMatch = false;
        return this.updateFormStatus();
    };
    DownloadForm.prototype.allSelectsChosen = function () {
        var selects = this.$el.find('select').filter(function () { return $(this).closest('.js-year.disabled').length === 0; });
        var memo = function (memo, el) {
            var _a, _b;
            var selectIsNonEmpty = !underscore_1.default.isEmpty((_b = (_a = $(el)) === null || _a === void 0 ? void 0 : _a.val()) === null || _b === void 0 ? void 0 : _b.toString());
            return memo && selectIsNonEmpty;
        };
        return underscore_1.default.reduce(selects, memo, true);
    };
    DownloadForm.prototype.radioSelected = function () {
        return this.$el.find('input:radio:checked').length > 0;
    };
    __decorate([
        withMName_1.withMName
    ], DownloadForm.prototype, "updateFormStatus", null);
    __decorate([
        withMName_1.withMName
    ], DownloadForm.prototype, "onChangeFormat", null);
    __decorate([
        withMName_1.withMName
    ], DownloadForm.prototype, "onSuggestionMatch", null);
    __decorate([
        withMName_1.withMName
    ], DownloadForm.prototype, "onSuggestionMiss", null);
    return DownloadForm;
}(Backbone.View));
exports.DownloadForm = DownloadForm;
